<template>
  <div ref="searchVillas">
    <div
      v-show="showOnly"
      :style="getLayering"
      :class="[
        'search-villa',
        'searchVilla',
        'villa-search',
        {
          'search-villa--page-region': region === 'region',
          'search-villa--section-nav': section === 'nav',
          'search-villa--page-exquisite': region === 'exquisite',
          'search-villa--page-exquisite-location': location === 'hero',
          'search-villa--sticky': isSticky && !isFooterinView,
          sticky: isSticky && !isFooterinView,
          'search-villa--space': region === 'homepage' && !isNav,
          ['search-villa--dropdown-' + openDropdownPosition]: openDropdownPosition && !isSticky
        }]"
    >
      <div v-if="!reducedSearch" class="search-villa__inner">
        <div
          v-if="!reducedSearch"
          :class="[
            'search-villa__inner__group',
            {
              'search-villa__inner__group--no-group': isGreece,
              noRegion: isGreece
            }
          ]"
        >
          <MultipleDestinations
            v-if="!isGreece"
            :postion-top="destinationsTop"
            :instanceName="instanceName"
          />
          <TTTDatePickerInput
            v-if="!reducedSearch"
            :key="getSVKey"
            picker-position="absolute"
            :within-modal="false"
            :instanceName="instanceName"
            :no-border="true"
            @visible="pickerVisibleChanged"
          />
          <GuestsDropdown v-if="!reducedSearch" />
          <BedroomsDropdown v-if="!reducedSearch && isDesktop" />

          <div>
            <button
              class="villa-search__submit btn-primary-dark-lrg"
              type="button"
              @click="search($event)"
            >
              {{ textFindVillas }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="isSticky && !isFooterinView"
      class="searchVilla-sticky-placeholder search-villa__sticky-placeholder"
    />
  </div>
</template>

<script>
import { _ } from 'vue-underscore';
import Bus from '../../events/bus';
import responsive from '../../mixins/responsive';
import routerLink from '../../mixins/routerLink';
import closeTab from '../../mixins/closeTab';
import uuid from '../../mixins/uuid';
import trackingHelper from '../../mixins/trackingHelper';
import TTTDatePickerInput from '../TTTDatePicker/TTTDatePickerInput.vue';
import MultipleDestinations from './MultipleDestinations.vue';
import GuestsDropdown from './GuestsDropdown.vue';
import BedroomsDropdown from './BedroomsDropdown.vue';

export default {
  name: 'DesktopSearchVilla',

  components: {
    TTTDatePickerInput,
    MultipleDestinations,
    GuestsDropdown,
    BedroomsDropdown,
  },
  mixins: [routerLink, closeTab, uuid, trackingHelper, responsive],
  props: {
    instanceName: { type: String, default: 'home' },
    textArrival: { type: String, required: true },
    textDeparture: { type: String, required: true },
    textFindVillas: { type: String, required: true },
    region: { type: String },
    location: { type: String },
    section: { type: String },
    showonly: { type: String },
    te: { type: Boolean },
    destinationsTop: { type: String, default: '72px' },
    trackingCategory: { type: String, required: false, default: 'topnav' }, // this is for GTM click tracking (either set to 'topnav' or 'hero')
    openDropdownPosition: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      svkey: Math.random(),
      pickerOpen: false,
    };
  },
  computed: {
    reducedSearch() {
      return window.innerWidth <= 770;
    },
    getLayering() {
      return {
        zIndex: this.pickerOpen ? '3000' : '101',
      };
    },
    isResultsPage() {
      return this.$store.getters['pages/currentPage']
        ? this.$store.getters['pages/currentPage'].templateId == 5
        : false;
    },
    isRegionsPage() {
      return this.$store.getters['pages/currentPage']
        ? this.$store.getters['pages/currentPage'].templateId == 24
        : false;
    },
    isNav() {
      return this.section === 'nav';
    },
    isFullHeight() {
      return this.$store.getters['pages/currentPage']
        ? this.$store.getters['pages/currentPage'].templateId == 3
        : false;
    },
    isHomeRegion() {
      return this.region == 'homepage';
    },
    isGreekIslandsRegion() {
      return this.region == 'greekislands';
    },
    isExquisiteDesktop() {
      return this.region === 'exquisite' && this.showonlyDesktop;
    },
    isExquisiteMobile() {
      return this.region === 'exquisite' && this.showonlyMobile;
    },
    showonlyDesktop() {
      return this.$mq === 'desktop' && this.showonly === 'desktop';
    },
    showonlyTablet() {
      return this.$mq === 'tablet' && this.showonly === 'tablet';
    },
    showonlyMobile() {
      return this.$mq === 'mobile' && this.showonly === 'mobile';
    },
    showOnlyTabletDesktop() {
      return (
        this.showonly === 'tabletdesktop' &&
        (this.$mq === 'tablet' || this.$mq === 'desktop')
      );
    },
    showOnly() {
      if (!this.$store.state.common.datepickerOpen) {
        return (
          this.showOnlyTabletDesktop ||
          this.showonlyMobile ||
          this.showonlyDesktop ||
          this.showonlyTablet ||
          this.isExquisiteDesktop ||
          this.isExquisiteMobile ||
          this.isHomeRegion ||
          this.isGreekIslandsRegion ||
          this.isNav
        );
      }
    },
    getSVKey() {
      return this.svkey;
    },
    dates: {
      get() {
        return this.$store.getters['filterbar/getDates'];
      },
      set(val) {
        this.$store.commit('filterbar/setDates', val);
      },
    },
    sticky: {
      get() {
        return this.$store.getters['searchvilla/getSticky'];
      },
      set(val) {
        this.$store.commit('searchvilla/setSticky', val);
      },
    },
    isSticky() {
      return this.sticky === true;
    },
    getDestinations() {
      return this.$store.getters['results/getDestinations'];
    },
    getSubDestinations() {
      return this.$store.getters['results/getSubDestinations'];
    },
    isGreece() {
      return this.$store.getters['pages/currentPage']
        ? this.$store.getters['pages/currentPage'].parentPageId == 1087
        : false;
    },
    isFooterinView() {
      return this.$store.getters['filterbar/getFooterInView'];
    },
    REGION_IDS() {
      return this.$store.getters['results/getRegionIDs'];
    },
  },
  mounted() {
    this.svkey = this.newUuidKey();
    window.addEventListener('resize', this.handleResize, { passive: true });
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    // this.calculateSticky();
    // setTimeout(() => this.calculateSticky(), 5000);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    pickerVisibleChanged(val) {
      // hack to toggle z-index
      if (val) {
        this.pickerOpen = val;
      } else {
        // delay to not be under content while animating out
        setTimeout(() => (this.pickerOpen = val), 300);
      }
    },
    search(ev) {
      ev.preventDefault();
      ev.stopPropagation();
      const selectedPeople = this.$store.getters['results/getPeople'];
      const selectedRooms = this.$store.getters['results/getBedrooms'];
      const destinationsIDs = this.getDestinations.map((des) => des.id);
      const destinationsNames = this.getDestinations.map((des) => des.name);
      const subDestinationsIDs = this.getSubDestinations.map((des) => des.id);

      // Hack for paxos & Antipaxos
      if (
        destinationsIDs.length > 0 &&
        destinationsIDs[0] === this.REGION_IDS.PAXOS
      ) {
        destinationsIDs.push(this.REGION_IDS.ANTIPAXOS);
      }

      const redirectTo = {
        url: '/results',
        params: {
          ...(destinationsIDs.length > 0 && {
            des: destinationsIDs.toString(),
          }),
          ...(subDestinationsIDs.length > 0 && {
            subdes: subDestinationsIDs.toString(),
          }),
          ...(this.dates &&
            this.dates.start && {
            from: moment(this.dates.start).format('DD MMM YYYY'),
          }),
          ...(this.dates &&
            this.dates.end && {
            to: moment(this.dates.end).format('DD MMM YYYY'),
          }),
          ...(selectedPeople != '' && { people: selectedPeople }),
          ...(selectedRooms != '' && { rooms: selectedRooms }),
        },
      };

      // track every search click (for GTM tracking) - see trackingHelper mixin
      this.trackSearchClick(this.trackingCategory, {
        ...redirectTo.params,
        destinations: destinationsIDs,
        desNames: destinationsNames,
        people: selectedPeople,
        rooms: selectedRooms,
      });
      let url = '/results?';
      if (destinationsIDs.length > 0) {
        url += `&des=${destinationsIDs.toString()}`;
      }
      if (subDestinationsIDs.length > 0) {
        url += `&subdes=${subDestinationsIDs.toString()}`;
      }
      if (this.dates && this.dates.start && this.dates.end) {
        url += `&startDate=${moment(this.dates.start).format('YYYY-MM-DD')}&endDate=${moment(this.dates.end).format('YYYY-MM-DD')}`;
      }
      if (selectedPeople) {
        url += `&people=${selectedPeople}`;
      }
      if (selectedRooms) {
        url += `&rooms=${selectedRooms}`;
      }

      // Store
      this.$store.commit('results/setThinkExquisite', this.te);
      window.location.href = url;
      this.isResultsPage
        ? Bus.$emit('filterProperties', 'SEARCH VILLA BAR')
        : null;
      this.closeTab();
    },
    calculateSticky() {
      if (this.$refs.searchVillas && !this.isNav) {
        const elementTop =
          this.$refs.searchVillas.getBoundingClientRect().top;
        const actualBottom = elementTop + 70;
        if (actualBottom < 0) {
          if (!this.sticky) this.sticky = true;
        } else {
          if (this.sticky) this.sticky = false;
        }
      }
    },
    handleResize: _.throttle(function () {
      this.calculateSticky();
    }, 200),
    handleScroll: _.throttle(function () {
      this.calculateSticky();
    }, 200),
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/settings/config.scss";

.search-villa {
  position: relative;
  width: 100%;
  height: 72px;
  margin: 0 auto 0 auto;
  display: flex;
  background-color: transparent;
  border-radius: 5px;
  justify-content: center;
  overflow: visible;

  &--space {
    margin: 0;
  }

  &--sticky {
    position: fixed;
    bottom: -72px;
    left: 0;
    right: 0;
    transition: transform 0.4s ease-in-out;
    transform: translateY(-72px);

  }

  &--page-region {
    display: inline-flex;
    min-width: auto;
    margin-top: 0;
  }

  &--section-nav {
    background-color: $offwhite !important;
  }

  &--page-exquisite {
    margin: 30px auto;
  }

  &__inner {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    width: 100%;
    height: 100%;
    overflow: visible;
    background-color: $stoneWhite;

    > div {
      flex: 1;

      &:first-child {
        margin-top: 0;
      }

      margin-top: 5px;

      &:first-child {
        margin-top: 0;
      }
    }

    .search-villa__inner__group {
      display: flex;
      justify-content: center;

      > div {
        flex: 1;
        border: 1px solid $stoneLight;
        border-left: 0;
      }

      > div:first-child {
        border-left: 1px solid $stoneLight;
      }

      > div:last-child {
        border-style: none;
      }
    }
  }

  .villa-search__select {
    margin: 0;

    select {
      &.destination {
        min-width: 100% !important;
      }

      width: 100%;
    }
  }

  .main-search-holder {
    min-width: 272px;
  }

  .villa-search__submit {
    min-width: 180px;
    @media (max-width: 1100px) {
      font-size: 15px;
    }
  }

  &__sticky-placeholder {
    display: block;
    visibility: hidden;
    height: 72px;
    margin: 24px;
  }
}

@media (min-width: 768px) {
  .search-villa {
    //max-width: 335px;
    background-color: transparent;

    &--section-nav {
      max-width: none;

      .search-villa__inner {
        flex-direction: column;
        flex-wrap: nowrap;
        > div {
          margin-top: 0;
        }
      }
    }

    &--page-exquisite {
      display: block;
      max-width: 1000px;
    }

    &--page-exquisite-location {
      display: none;
    }

    .villa-search__select {
      &:last-child {
        margin: 0;
      }

      select {
        width: 100%;
      }
    }
  }
}

@media (max-width: 768px) {
  .search-villa__inner__group > div:last-child {
    margin: 0;
  }
}
</style>
